<template>
  <landing-page
    label="bookYourAppointment.bookYourAppointment"
    description="bookYourAppointment.bookYourAppointmentDesc"
    labelColor="#603813"
    descColor="#603813"
    :eggImgObj="{ componentName: 'bookYourAppointment', imgName: 'bookYourAppointmentIntro', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconBrownRight', imgFormat: 'svg' }"
    class="mb-10"
  />
</template>

<script setup lang="ts">
import { useBookYourAppointmentStore } from "@/stores/bookYourAppointment";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const bookYourAppointmentStore = useBookYourAppointmentStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>